// 图片资源
import SOURCE_ND_ICON from '@public/assets/source_netdoc.svg'
import SOURCE_TEAMS_ICON from '@public/assets/source_teams.svg'
import SOURCE_ZOOM_ICON from '@public/assets/source_zoom.svg'
import SOURCE_MIRA_ICON from '@public/assets/source_mira.svg'
import SOURCE_WORD_ICON from '@public/assets/source_word.svg'
import SOURCE_EXCEL_ICON from '@public/assets/source_excel.svg'
import SOURCE_PPT_ICON from '@public/assets/source_ppt.svg'
import SOURCE_WORD_ONLINE_ICON from '@public/assets/source_word_online.svg'
import SOURCE_EXCEL_ONLINE_ICON from '@public/assets/source_excel_online.svg'
import SOURCE_PPT_ONLINE_ICON from '@public/assets/source_ppt_online.svg'
import SOURCE_OFFICE_DEFAULT_ICON from '@public/assets/source_office_default.svg'
import SOURCE_CALENDAR_ICON from '@public/assets/source_calendar.svg'
import SOURCE_CALENDAR_REMINDER_ICON from '@public/assets/source_calendar_reminder.svg'
import SOURCE_IMANAGE_ICON from '@public/assets/source_imanage.svg'
import SOURCE_OUTLOOK_ICON from '@public/assets/source_outlook.svg'
import SOURCE_CHROME_ICON from '@public/assets/source_chrome.svg'
import SOURCE_BROWSER_ICON from '@public/assets/source_browser.svg'
import SOURCE_EDGE_ICON from '@public/assets/source_edge.svg'
import SOURCE_ADOBE_ICON from '@public/assets/adobe_acrobat.svg'
import SOURCE_DXL_ICON from '@public/assets/dxl.png'
import SOURCE_AI_ICON from '@public/assets/ai.png'
import SOURCE_BMP_ICON from '@public/assets/bmp.png'
import SOURCE_CSV_ICON from '@public/assets/csv.png'
import SOURCE_DOC_ICON from '@public/assets/doc.png'
import SOURCE_DOCT_ICON from '@public/assets/doct.png'
import SOURCE_DOCX_ICON from '@public/assets/docx.png'
import SOURCE_EML_ICON from '@public/assets/eml.png'
import SOURCE_GIF_ICON from '@public/assets/gif.png'
import SOURCE_HTML_ICON from '@public/assets/html.png'
import SOURCE_JPEG_ICON from '@public/assets/jpeg.png'
import SOURCE_JPG_ICON from '@public/assets/jpg.png'
import SOURCE_JSON_ICON from '@public/assets/json.png'
import SOURCE_LFD_ICON from '@public/assets/lfd.png'
import SOURCE_MSG_ICON from '@public/assets/msg.png'
import SOURCE_ONE_ICON from '@public/assets/one.png'
import SOURCE_QPW_ICON from '@public/assets/qpw.png'
import SOURCE_PCX_ICON from '@public/assets/pcx.png'
import SOURCE_PDF_ICON from '@public/assets/pdf.png'
import SOURCE_PLAIN_ICON from '@public/assets/plain.png'
import SOURCE_PNG_ICON from '@public/assets/png.png'
import SOURCE_PPTX_ICON from '@public/assets/pptx.png'
import SOURCE_PUB_ICON from '@public/assets/pub.png'
import SOURCE_RTF_ICON from '@public/assets/rtf.png'
import SOURCE_SHW_ICON from '@public/assets/shw.png'
import SOURCE_TIF_ICON from '@public/assets/tif.png'
import SOURCE_TIFF_ICON from '@public/assets/tiff.png'
import SOURCE_TXT_ICON from '@public/assets/txt.png'
import SOURCE_URL_ICON from '@public/assets/url.png'
import SOURCE_VSD_ICON from '@public/assets/vsd.png'
import SOURCE_WMF_ICON from '@public/assets/wmf.png'
import SOURCE_WPD_ICON from '@public/assets/wpd.png'
import SOURCE_XLS_ICON from '@public/assets/xls.png'
import SOURCE_XLSX_ICON from '@public/assets/xlsx.png'
import SOURCE_XML_ICON from '@public/assets/xml.png'
import SOURCE_ZIP_ICON from '@public/assets/zip.png'
import SOURCE_AVI_ICON from '@public/assets/avi.svg'
import SOURCE_MOV_ICON from '@public/assets/mov.svg'
import SOURCE_MP3_ICON from '@public/assets/mp3.svg'
import SOURCE_MP4_ICON from '@public/assets/mp4.svg'
import SOURCE_WAV_ICON from '@public/assets/wav.svg'
import SOURCE_M4A_ICON from '@public/assets/m4a.svg'

import SOURCE_CLOCKING_STATIC_ICON from '@public/assets/clocking.svg'
import SOURCE_CLOCKING_ICON from '@public/assets/play-clocking.svg'
import SOURCE_CLOCKING_RUNNING_ICON from '../../../public/assets/running-clocking.svg'
import SOURCE_GOOGLE_GMAIL_ICON from '@public/assets/google/gmail.svg'
import SOURCE_GOOGLE_DRIVE_ICON from '@public/assets/google/drive.svg'
import SOURCE_GOOGLE_MEET_ICON from '@public/assets/google/meet.svg'
import SOURCE_GOOGLE_CALENDAR_ICON from '@public/assets/google/calendar.svg'
import SOURCE_GOOGLE_CALENDAR_REMINDER_ICON from '@public/assets/google/calendar-reminder.svg'
import SOURCE_GOOGLE_DOCS_ICON from '@public/assets/google/docs.svg'
import SOURCE_GOOGLE_SHEETS_ICON from '@public/assets/google/sheets.svg'
import SOURCE_GOOGLE_SLIDES_ICON from '@public/assets/google/slides.svg'
import SOURCE_GOOGLE_SITE_ICON from '@public/assets/google/site.svg'
import SOURCE_GOOGLE_FORMS_ICON from '@public/assets/google/forms.svg'
import SOURCE_GOOGLE_MAP_ICON from '@public/assets/google/Map.svg'
import SOURCE_GOOGLE_SCRIPT_ICON from '@public/assets/google/script.svg'
import SOURCE_GOOGLE_DRAWING_ICON from '@public/assets/google/Drawing.svg'

export {
  SOURCE_CLOCKING_STATIC_ICON,
  SOURCE_CLOCKING_ICON,
  SOURCE_CLOCKING_RUNNING_ICON,
}

const OFFICE_APPS = ['Word', 'Excel', 'PowerPoint']
const OFFICE_ONLINE_SUFFIX = ' Online'
const OFFICE_DESKTOP_SOURCE = 'Desktop Agent'
const EMAIL_APPS = new Set(['outlook', 'gmail'])
const WEB_APPS = new Set(['chrome', 'edge'])
const DEFAULT_UNAVAILABLE_TIME_MESSAGE =
  'A "?" indicates that either the start or stop time is unavailable.'
const OUTLOOK_COMPOSE_UNAVAILABLE_TIME_MESSAGE =
  'Create new emails from the Inbox. Emails created from other folders may not include the start time.'

const hasEmailSource = (item = {}) => {
  const sources = [
    ...(Array.isArray(item.apps) ? item.apps : []),
    item.non_svc_source,
  ]

  return sources.some(source =>
    EMAIL_APPS.has(String(source || '').toLowerCase())
  )
}

export function isEmailActivityItem(item = {}) {
  if (!item) return false
  if (hasEmailSource(item)) return true
  return (
    Array.isArray(item.slots) && item.slots.some(slot => hasEmailSource(slot))
  )
}

const hasWebSource = (item = {}) => {
  const sources = [
    ...(Array.isArray(item.apps) ? item.apps : []),
    item.non_svc_source,
  ]

  return sources.some(source =>
    WEB_APPS.has(String(source || '').toLowerCase())
  )
}

export function isWebActivityItem(item = {}) {
  if (!item) return false
  if (hasWebSource(item)) return true
  return (
    Array.isArray(item.slots) && item.slots.some(slot => hasWebSource(slot))
  )
}

export function getUrlDomain(value) {
  if (!value) return ''

  try {
    const url = new URL(
      /^https?:\/\//i.test(value) ? value : `https://${value}`
    )
    return url.hostname.toLowerCase()
  } catch {
    return ''
  }
}

export function getHttpsDomain(value) {
  if (!value) return ''

  try {
    const url = new URL(
      /^https?:\/\//i.test(value) ? value : `https://${value}`
    )
    if (!['http:', 'https:'].includes(url.protocol)) return ''

    return `https://${url.hostname.toLowerCase()}`
  } catch {
    return ''
  }
}

export const isOutlookComposeActivity = (item = {}) => {
  const sources = [
    ...(Array.isArray(item.apps) ? item.apps : []),
    item.non_svc_source,
  ]
  const isOutlook = sources.some(
    source => String(source || '').toLowerCase() === 'outlook'
  )
  const activityType = String(item.metadata?.type || '').toLowerCase()

  return isOutlook && ['draft', 'sent'].includes(activityType)
}

export function getUnavailableTimeMessage(item = {}) {
  const isOutlookCompose =
    isOutlookComposeActivity(item) ||
    (Array.isArray(item.slots) && item.slots.some(isOutlookComposeActivity))

  return isOutlookCompose
    ? OUTLOOK_COMPOSE_UNAVAILABLE_TIME_MESSAGE
    : DEFAULT_UNAVAILABLE_TIME_MESSAGE
}

export function isClockingItem(item = {}) {
  return (
    (item.apps || []).includes('Clocking') || item.non_svc_source === 'Clocking'
  )
}

export function isActuallyRunningClocking(item = {}) {
  if (!item) return false
  if (item.isActuallyTiming != null) return !!item.isActuallyTiming
  if (!isClockingItem(item)) return false

  const hasStop =
    (item.stop != null && item.stop !== '') ||
    (item.stop_display != null && item.stop_display !== '')
  const canBeRunningStatus =
    !item.status || ['fetched', 'created'].includes(item.status)

  return canBeRunningStatus && !hasStop
}

export function isRunningClocking(item = {}) {
  if (!item) return false
  if (item.isTiming) return true
  if (isActuallyRunningClocking(item)) return true
  if (Array.isArray(item.slots))
    return item.slots.some(slot => isRunningClocking(slot))
  return false
}

export function isFinalizedClocking(item = {}) {
  if (!item) return false
  const hasClockingSource =
    isClockingItem(item) ||
    (Array.isArray(item.slots) && item.slots.some(slot => isClockingItem(slot)))
  if (!hasClockingSource) return false

  const status = String(item.status || '').toLowerCase()
  const subStatus = String(item.sub_status || '').toLowerCase()

  return (
    ['accepted', 'released', 'ready2release', 'releasing'].includes(status) ||
    subStatus === 'ready_to_release' ||
    (Array.isArray(item.slots) &&
      item.slots.some(slot => isFinalizedClocking(slot)))
  )
}

export function isReminderCalendarItem(item = {}) {
  const apps = item.apps || []

  return (
    (apps.includes('OutlookCalendar') || apps.includes('gcalendar')) &&
    String(item?.metadata?.type || '').toLowerCase() === 'reminder'
  )
}

// MIRA-4371: Reminder and Free calendar events share the bell icon.
// Keep all-day metadata and duration behavior independent of icon selection.
const usesCalendarReminderIcon = (item = {}) =>
  isReminderCalendarItem(item) ||
  String(item?.metadata?.status || '').toLowerCase() === 'free'

export function isAllDayCalendarItem(item = {}) {
  const apps = item.apps || []

  return (
    (apps.includes('OutlookCalendar') || apps.includes('gcalendar')) &&
    String(item?.metadata?.type || '').toLowerCase() === 'all-day'
  )
}

// Outlook Graph showAs raw values (stored in metadata.status) -> display labels.
const OUTLOOK_SHOW_AS_LABELS = {
  free: 'Free',
  tentative: 'Tentative',
  busy: 'Busy',
  workingelsewhere: 'Working Elsewhere',
  oof: 'Out of Office',
}

const GOOGLE_OOO_ALL_DAY_MESSAGE =
  'You have an all-day calendar event. Please review and adjust the duration before submitting your time entry.'
const OUTLOOK_ALL_DAY_MESSAGE_FALLBACK =
  'You have an all-day calendar event. Please review and adjust the duration before submitting your time entry.'

export function getAllDayCalendarMessage(item = {}) {
  if ((item.apps || []).includes('gcalendar')) {
    return GOOGLE_OOO_ALL_DAY_MESSAGE
  }

  const status = String(item?.metadata?.status || '')
  const label = OUTLOOK_SHOW_AS_LABELS[status.toLowerCase()] || status

  return label
    ? `You have an all-day calendar event marked as ${label}. Please review and adjust the duration before submitting your time entry.`
    : OUTLOOK_ALL_DAY_MESSAGE_FALLBACK
}

const isOfficeOnlineKey = key =>
  key.endsWith(OFFICE_ONLINE_SUFFIX) &&
  OFFICE_APPS.includes(key.slice(0, -OFFICE_ONLINE_SUFFIX.length))

const getOfficeOnlineKey = app => `${app}${OFFICE_ONLINE_SUFFIX}`

const shouldHideBrowserSourceIcon = (item = {}) => {
  if (!item.source_doc_id) return false
  if (!hasWebSource(item)) return false
  // When apps only contain Chrome/Edge (no other apps), keep the browser icon
  const apps = item.apps || []
  const hasNonWebApp = apps.some(
    app => !WEB_APPS.has(String(app).toLowerCase())
  )
  return hasNonWebApp
}

const getOwnItemSourceKeys = (item = {}) => {
  const hideBrowserSourceIcon = shouldHideBrowserSourceIcon(item)
  const keys = (item.apps || [])
    .filter(Boolean)
    .map(app => {
      if (app === 'OutlookCalendar' && usesCalendarReminderIcon(item)) {
        return 'OutlookCalendar Free'
      }
      if (app === 'gcalendar' && usesCalendarReminderIcon(item)) {
        return 'gcalendar Free'
      }
      if (
        OFFICE_APPS.includes(app) &&
        item.non_svc_source !== OFFICE_DESKTOP_SOURCE
      ) {
        return getOfficeOnlineKey(app)
      }
      return app
    })
    .filter(
      key =>
        !(hideBrowserSourceIcon && WEB_APPS.has(String(key).toLowerCase()))
    )

  if (isClockingItem(item) && !keys.includes('Clocking')) {
    keys.push('Clocking')
  }

  return keys
}

const addSourceKey = (keys, key) => {
  if (!key) return

  if (isOfficeOnlineKey(key)) {
    const baseApp = key.slice(0, -OFFICE_ONLINE_SUFFIX.length)
    keys.delete(baseApp)
    keys.add(key)
    return
  }

  if (OFFICE_APPS.includes(key) && keys.has(getOfficeOnlineKey(key))) {
    return
  }

  keys.add(key)
}

// Returns source keys for an item. TimeEntry cards may carry slots; in that case
// source identity is derived from the slots because merged entries can lose
// per-slot non_svc_source detail.
export function getItemSourceKeys(item = {}) {
  const keys = new Set()

  if (Array.isArray(item.slots) && item.slots.length) {
    item.slots.forEach(slot => {
      getOwnItemSourceKeys(slot).forEach(key => addSourceKey(keys, key))
    })
  }

  if (!keys.size) {
    getOwnItemSourceKeys(item).forEach(key => addSourceKey(keys, key))
  }
  return Array.from(keys)
}

// Check if an item matches a source filter key, accounting for online vs desktop Office apps.
export function itemMatchesSourceKey(item, sourceKey) {
  return getItemSourceKeys(item).includes(sourceKey)
}

export function getSourceIcon(key, item) {
  if (key === 'Clocking') {
    if (isFinalizedClocking(item)) {
      return sourceIconMapping['Clocking Static']
    }
    if (isRunningClocking(item)) {
      return sourceIconMapping['Clocking Running']
    }
  }
  if (key === 'OutlookCalendar' && usesCalendarReminderIcon(item)) {
    return sourceIconMapping['OutlookCalendar Reminder']
  }
  if (key === 'gcalendar' && usesCalendarReminderIcon(item)) {
    return sourceIconMapping['gcalendar Free']
  }
  return sourceIconMapping[key]
}

export function getItemSourceIcons(item) {
  return getItemSourceKeys(item)
    .map(key => getSourceIcon(key, item))
    .filter(Boolean)
}

// 源文件类型到图标映射
export const sourceIconMapping = {
  gmail: SOURCE_GOOGLE_GMAIL_ICON,
  gdrive: SOURCE_GOOGLE_DRIVE_ICON,
  gmeet: SOURCE_GOOGLE_MEET_ICON,
  gcalendar: SOURCE_GOOGLE_CALENDAR_ICON,
  'gcalendar Free': SOURCE_GOOGLE_CALENDAR_REMINDER_ICON,
  gdoc: SOURCE_GOOGLE_DOCS_ICON,
  gsheet: SOURCE_GOOGLE_SHEETS_ICON,
  gslide: SOURCE_GOOGLE_SLIDES_ICON,
  gdrawing: SOURCE_GOOGLE_DRAWING_ICON,
  gform: SOURCE_GOOGLE_FORMS_ICON,
  gsite: SOURCE_GOOGLE_SITE_ICON,
  gmap: SOURCE_GOOGLE_MAP_ICON,
  gscript: SOURCE_GOOGLE_SCRIPT_ICON,
  'Clocking Static': SOURCE_CLOCKING_STATIC_ICON,
  Clocking: SOURCE_CLOCKING_ICON,
  'Clocking Running': SOURCE_CLOCKING_RUNNING_ICON,
  NetDocuments: SOURCE_ND_ICON,
  Teams: SOURCE_TEAMS_ICON,
  Zoom: SOURCE_ZOOM_ICON,
  'iManage Work': SOURCE_IMANAGE_ICON,
  'iManage Cloud': SOURCE_IMANAGE_ICON,
  OutlookCalendar: SOURCE_CALENDAR_ICON,
  'OutlookCalendar Free': SOURCE_CALENDAR_REMINDER_ICON,
  'OutlookCalendar Reminder': SOURCE_CALENDAR_REMINDER_ICON,
  Browser: SOURCE_BROWSER_ICON,
  Chrome: SOURCE_CHROME_ICON,
  Edge: SOURCE_EDGE_ICON,
  'Mira App': SOURCE_MIRA_ICON,
  Word: SOURCE_WORD_ICON,
  'Word Online': SOURCE_WORD_ONLINE_ICON,
  Excel: SOURCE_EXCEL_ICON,
  'Excel Online': SOURCE_EXCEL_ONLINE_ICON,
  PowerPoint: SOURCE_PPT_ICON,
  'PowerPoint Online': SOURCE_PPT_ONLINE_ICON,
  Outlook: SOURCE_OUTLOOK_ICON,
  PDF: SOURCE_ADOBE_ICON,
  Office: SOURCE_OFFICE_DEFAULT_ICON,
  'Windows Agent': SOURCE_OFFICE_DEFAULT_ICON,
  ai: SOURCE_AI_ICON,
  bmp: SOURCE_BMP_ICON,
  csv: SOURCE_CSV_ICON,
  doc: SOURCE_DOC_ICON,
  doct: SOURCE_DOCT_ICON,
  docx: SOURCE_DOCX_ICON,
  dxl: SOURCE_DXL_ICON,
  eml: SOURCE_EML_ICON,
  gif: SOURCE_GIF_ICON,
  html: SOURCE_HTML_ICON,
  jpeg: SOURCE_JPEG_ICON,
  jpg: SOURCE_JPG_ICON,
  json: SOURCE_JSON_ICON,
  lfd: SOURCE_LFD_ICON,
  msg: SOURCE_MSG_ICON,
  one: SOURCE_ONE_ICON,
  qpw: SOURCE_QPW_ICON,
  pcx: SOURCE_PCX_ICON,
  pdf: SOURCE_PDF_ICON,
  plain: SOURCE_PLAIN_ICON,
  png: SOURCE_PNG_ICON,
  ppt: SOURCE_PPT_ICON,
  pptx: SOURCE_PPTX_ICON,
  pub: SOURCE_PUB_ICON,
  rtf: SOURCE_RTF_ICON,
  shw: SOURCE_SHW_ICON,
  tif: SOURCE_TIF_ICON,
  tiff: SOURCE_TIFF_ICON,
  txt: SOURCE_TXT_ICON,
  url: SOURCE_URL_ICON,
  vsd: SOURCE_VSD_ICON,
  wmf: SOURCE_WMF_ICON,
  wpd: SOURCE_WPD_ICON,
  xls: SOURCE_XLS_ICON,
  xlsx: SOURCE_XLSX_ICON,
  xml: SOURCE_XML_ICON,
  zip: SOURCE_ZIP_ICON,
  avi: SOURCE_AVI_ICON,
  mov: SOURCE_MOV_ICON,
  mp3: SOURCE_MP3_ICON,
  mp4: SOURCE_MP4_ICON,
  wav: SOURCE_WAV_ICON,
  m4a: SOURCE_M4A_ICON,
}

export const sourceNameMapping = {
  gmail: 'Google Email',
  gdrive: 'Google Drive',
  gmeet: 'Google Meet',
  gcalendar: 'Google Calendar',
  'gcalendar Free': 'Calendar Reminder',
  gdoc: 'Google Docs',
  gsheet: 'Google Sheets',
  gslide: 'Google Slides',
  gdrawing: 'Google Drawings',
  gform: 'Google Forms',
  gsite: 'Google Sites',
  gmap: 'My Maps',
  gscript: 'Google Apps Script',
  'Clocking Static': 'Clocking',
  Clocking: 'Clocking',
  'Clocking Running': 'Clocking',
  NetDocuments: 'NetDocuments',
  'Mira App': 'MIRA',
  Browser: 'Browser',
  Chrome: 'Chrome',
  Edge: 'Edge',
  'iManage Work': 'iManage',
  'iManage Cloud': 'iManage',
  Zoom: 'Zoom',
  Teams: 'Teams',
  Outlook: 'Outlook',
  OutlookCalendar: 'Meeting',
  'OutlookCalendar Free': 'Calendar Reminder',
  Word: 'Word',
  'Word Online': 'Word Online',
  Excel: 'Excel',
  'Excel Online': 'Excel Online',
  PowerPoint: 'PPT',
  'PowerPoint Online': 'PPT Online',
  PDF: 'PDF',
  Office: 'Office',
  'Windows Agent': 'Agent',
  ai: 'Ai',
  bmp: 'Bmp',
  csv: 'Csv',
  doc: 'Doc',
  doct: 'Doct',
  docx: 'Docx',
  dxl: 'Dxl',
  eml: 'Eml',
  gif: 'Gif',
  html: 'Html',
  jpeg: 'Jpeg',
  jpg: 'Jpg',
  json: 'Json',
  lfd: 'Lfd',
  msg: 'Msg',
  one: 'One',
  qpw: 'Qpw',
  pcx: 'Pcx',
  pdf: 'Pdf',
  plain: 'Plain',
  png: 'Png',
  ppt: 'Ppt',
  pptx: 'Pptx',
  pub: 'Pub',
  rtf: 'Rtf',
  shw: 'Shw',
  tif: 'Tif',
  tiff: 'Tiff',
  txt: 'Txt',
  url: 'Url',
  vsd: 'Vsd',
  wmf: 'Wmf',
  wpd: 'Wpd',
  xls: 'Xls',
  xlsx: 'Xlsx',
  xml: 'Xml',
  zip: 'Zip',
  avi: 'Avi',
  mov: 'Mov',
  mp3: 'Mp3',
  mp4: 'Mp4',
  wav: 'Wav',
  m4a: 'M4a',
}

export const sourceColorMapping = {
  gmail: '#FC413D',
  gdrive: '#3589FF ',
  gmeet: '#FED713',
  gcalendar: '#3589FF',
  gdoc: '#3186FF',
  gsheet: '#0EBC5F',
  gslide: '#FFC60B',
  gdrawing: '#EEA7A0',
  gform: '#5746E3',
  gsite: '#FED713',
  gmap: '#94D240',
  gscript: '#FBBC04',
  Clocking: '#9E9E9E',
  Teams: '#4C53BB',
  Zoom: '#4188FC',
  'iManage Work': '#3B68F0',
  'iManage Cloud': '#3B68F0',
  OutlookCalendar: '#02B2F3',
  Browser: '#4770EA',
  Chrome: '#FBBF0F',
  Edge: '#30C2E1',
  'Mira App': '#865BDF',
  Word: '#2064C2',
  'Word Online': '#2064C2',
  Excel: '#4BB063',
  'Excel Online': '#4BB063',
  PowerPoint: '#FF9505',
  'PowerPoint Online': '#FF9505',
  Outlook: '#ACE4FF',
  PDF: '#B40838',
  Office: '#FF7C01',
  'Windows Agent': '#FF7C01',
  ai: '#FF7C01',
  bmp: '#8B5F3E',
  csv: '#22A366',
  doc: '#175ABD',
  doct: '#175ABD',
  docx: '#175ABD',
  dxl: '#695ACD',
  eml: '#6E4C9E',
  gif: '#FFD966',
  html: '#E35026',
  jpeg: '#4990E2',
  jpg: '#4990E2',
  json: '#E35026',
  lfd: '#654321',
  msg: '#6E4C9E',
  one: '#771AAA',
  qpw: '#2E8B58',
  pcx: '#444444',
  pdf: '#D93832',
  plain: '#808080',
  png: '#4990E2',
  ppt: '#D24726',
  pptx: '#D24726',
  pub: '#207346',
  rtf: '#013366',
  shw: '#000000',
  tif: '#4990E2',
  tiff: '#4990E2',
  txt: '#808080',
  url: '#1EA1F1',
  vsd: '#3955A3',
  wmf: '#254483',
  wpd: '#A0522D',
  xls: '#0F7C41',
  xlsx: '#0F7C41',
  xml: '#E35026',
  zip: '#F4B400',
  avi: '#FFD966',
  mov: '#FFD966',
  mp3: '#1FA396',
  mp4: '#FFD966',
  wav: '#1FA396',
  m4a: '#39C19E',
}
